export const FETCH_ALL_BLOGS_REQUEST = 'FETCH_ALL_BLOGS_REQUEST'
export const FETCH_ALL_BLOGS_SUCCESS = 'FETCH_ALL_BLOGS_SUCCESS'
export const FETCH_ALL_BLOGS_FAILURE = 'FETCH_ALL_BLOGS_FAILURE'

export const FETCH_SINGLE_BLOG_REQUEST = 'FETCH_SINGLE_BLOG_REQUEST'
export const FETCH_SINGLE_BLOG_SUCCESS = 'FETCH_SINGLE_BLOG_SUCCESS'
export const FETCH_SINGLE_BLOG_FAILURE = 'FETCH_SINGLE_BLOG_FAILURE'

export const CREATE_BLOG_REQUEST = 'CREATE_BLOG_REQUEST'
export const CREATE_BLOG_SUCCESS = 'CREATE_BLOG_SUCCESS'
export const CREATE_BLOG_FAILURE = 'CREATE_BLOG_FAILURE'

export const DELETE_BLOG = 'DELETE_BLOG'

export const UPDATE_BLOG_REQUEST = 'UPDATE_BLOG_REQUEST'
export const UPDATE_BLOG_SUCCESS = 'UPDATE_BLOG_SUCCESS'
export const UPDATE_BLOG_FAILURE = 'UPDATE_BLOG_FAILURE'
